// extracted by mini-css-extract-plugin
export default {"header":"style_header__zheek","title":"style_title__ZSJ-y","deleteButton":"style_deleteButton__XSEnI"};